import {RoutesParts} from '../../../constants/routes-parts';

export const JumioRoutesPaths = {
  JUMIO: RoutesParts.JUMIO,
  SUCCESS: RoutesParts.JUMIO + RoutesParts.SUCCESS,
  ERROR: RoutesParts.JUMIO + '/error'
};
